<template>
  <div class="org_cla">
    <el-tree
      class="dept-tree-cla"
      :data="orgData"
      :props="defaultProps"
      :default-checked-keys="defaultKey"
      default-expand-all
      node-key="id"
      :highlight-current="true"
      :expand-on-click-node="true"
      :check-on-click-node="true"
      @node-click="nodeClick"
      :filter-node-method="filterNode"
      ref="deptTree"
    >
      <div
        :class="{ 'custom-tree-node': true, 'leaf-node-cla': node.isLeaf }"
        slot-scope="{ node, data }"
      >
        <span class="node-text-cla">{{ node.label }}</span>
        <zk-operate-bar
          v-if="showDeptOperation"
          :onlyIcon="true"
          @remove="remove(data)"
          @add="add(data)"
          @update="update(data)"
        ></zk-operate-bar>
      </div>
    </el-tree>

    <el-dialog
      :title="title"
      :visible.sync="orgVisible"
      width="40%"
      @close="handleOrgClose"
    >
      <el-form :model="orgForm" ref="org" :rules="orgRules" label-width="120px">
        <el-form-item
          :label="this.$t('orgTree.parentCode')"
          props="orgCode"
          v-if="!isAddParent"
        >
          <el-input
            v-model.trim="orgForm.parentOrgCode"
            :placeholder="this.$t('orgTree.parentCodeTip')"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('orgTree.parentName')"
          props="parentName"
          v-if="!isAddParent"
        >
          <el-input
            v-model.trim="orgForm.parentName"
            :placeholder="this.$t('orgTree.parentNameTip')"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('orgTree.deptCode')" prop="orgCode">
          <el-input
            v-model.trim="orgForm.orgCode"
            :placeholder="this.$t('orgTree.deptCodeTip')"
            :disabled="isOrgUpdate ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('orgTree.deptName')" prop="orgName">
          <el-input
            v-model.trim="orgForm.orgName"
            :placeholder="this.$t('orgTree.deptNameTip')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleOrgClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="sumbitOrg">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrgStructure,
  getOrgType,
  addOrg,
  updateOrg,
  deleteOrg
} from '@/services/enterpriseApi.js'
import { validatorInputEmptyRule } from '@/utils/validatorRule.js'
import { mapActions, mapGetters } from 'vuex'

import Vue from 'vue'
export default {
  data() {
    return {
      orgTypeList: [],
      defaultKey: [],
      orgType: '',
      filterText: '',
      orgData: [],
      defaultProps: {
        children: 'children',
        label: 'organizationName'
      },
      selectedDept: {},
      dialogVisible: false,
      orgVisible: false,
      title: this.$t('orgTree.add'),
      isUpdate: false,
      isOrgUpdate: false,
      orgTypeForm: {
        orgTypeName: '',
        companyId: ''
      },
      orgTypeRules: {
        orgTypeName: [
          { required: true, message: '请输入组织架构类型', trigger: 'blur' }
        ]
      },
      row: [],
      isAddParent: false,
      orgForm: {
        orgCode: '',
        orgName: '',
        parentOrgCode: '',
        parentName: '',
        orgType: '',
        orgTypeName: '',
        companyId: '',
        id: ''
      },
      orgRules: {
        orgCode: validatorInputEmptyRule(true, 16),
        orgName: validatorInputEmptyRule(true, 16)
      },
      companyId: '',
      details: [],
      showDeptOperation: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.getOrgData()
        clearTimeout(t)
      }, 300)
    })
  },
  watch: {
    filterText(val) {
      this.$refs.deptTree.filter(val)
    },
    $route: {
      handler(to, form) {
        if (to.path === '/enterpriseAdmin/employee') {
          this.showDeptOperation = false
        } else {
          this.showDeptOperation = true
        }
      },
      immediate: true
    }
  },
  props: {
    isSelectDefault: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      getOrgType: 'getOrgType'
    })
  },
  methods: {
    ...mapActions(['setOrgType']),

    add(data) {
      this.title = this.$t('orgTree.add')
      this.isOrgUpdate = false
      this.isAddParent = false
      this.orgVisible = true
      this.orgForm.parentOrgCode = data.organizationCode
      this.orgForm.parentName = data.organizationName
    },
    update(data) {
      this.title = this.$t('orgTree.update')
      this.isOrgUpdate = true
      this.orgVisible = true
      this.isAddParent = true
      this.orgForm.orgCode = data.organizationCode
      this.orgForm.orgName = data.organizationName
      this.orgForm.id = data.id
    },
    remove(data) {
      if (data.level && data.level === '1') {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: this.$t('department.notDeleteRoot'),
          type: 'warning'
        })
        return
      }
      if (data.children && data.children.length > 0) {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: this.$t('department.notDeleteDept'),
          type: 'warning'
        })
        return
      }
      const h = this.$createElement
      this.$msgbox({
        title: this.$t('common.warningNotice'),
        message: h('p', null, this.$t('department.confirmDeleteDeptTip')),
        showCancelButton: true,
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = this.$t('orgTree.execute')
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
                let params = {
                  orgCode: data.organizationCode,
                  companyId: this.companyId
                }
                deleteOrg(params)
                  .then(data => {
                    if (data.code === '00000000') {
                      this.getOrgData()
                    } else {
                      this.$message.error(data.message)
                    }
                  })
                  .catch(e => {})
              }, 300)
            }, 3000)
          } else {
            done()
          }
        }
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    sumbitOrg() {
      this.orgTypeList.filter(item => {
        if (item.id === this.orgType) {
          this.details = item
        }
      })
      this.$refs.org.validate(valid => {
        if (valid) {
          if (!this.isOrgUpdate) {
            // 添加
            this.orgForm.orgTypeName = this.details.typeName
            this.orgForm.orgType = this.details.type
            this.orgForm.companyId = this.details.companyId
            this.orgForm.id = this.details.id
            addOrg(this.orgForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('orgTree.createOrg'))
                  this.handleOrgClose()
                  this.getOrgData()
                } else {
                  this.$message.error(data.message)
                  this.handleOrgClose()
                }
              })
              .catch(e => {})
          } else {
            // 更新
            updateOrg(this.orgForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('orgTree.updateOrg'))
                  this.handleOrgClose()
                  this.getOrgData()
                } else {
                  this.$message.error(data.message)
                  this.handleOrgClose()
                }
              })
              .catch(e => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addParent() {
      if (!this.orgType) {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: '请选择组织架构类型，再进行添加组织架构',
          type: 'warning'
        })
        return
      }
      this.isAddParent = true
      this.orgVisible = true
      this.isOrgUpdate = false
    },
    handleOrgClose() {
      this.orgVisible = false
      this.orgForm.orgCode = ''
      this.orgForm.orgName = ''
      this.orgForm.parentOrgCode = ''
      this.orgForm.orgType = ''
      this.orgForm.orgTypeName = ''
      this.$refs.org.resetFields()
    },

    handleClose() {
      this.dialogVisible = false
      this.orgTypeForm.orgTypeName = ''
      this.orgTypeForm.companyId = ''
      this.isUpdate = false
    },
    nodeClick(data, Node) {
      this.$emit('selectNode', Node)
    },
    change(data) {
      this.getOrgData()
      this.orgTypeList.filter(item => {
        if (item.id === data) {
          this.details = item
        }
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },

    setCurrentKey(id) {
      this.$refs.deptTree.setCurrentKey(id)
    },
    getOrgData() {
      try {
        this.companyId = sessionStorage.getItem('companyId')
      } catch (error) {
        console.log(error)
      }
      let params = {
        companyId: this.companyId
      }
      getOrgStructure(params)
        .then(data => {
          if (data.code === '00000000') {
            this.orgData = data.payload.results.organizationTree
            this.$emit('getOrgTree', this.orgData)
            if (this.orgData && this.orgData.length > 0) {
              if (this.isSelectDefault) {
                Vue.nextTick(() => {
                  let id = this.orgData[0].id
                  let node = this.$refs.deptTree.getNode(id)
                  this.$emit('selectNode', node)
                })
              } else {
                this.$emit('selectNode', null)
              }
            }
          } else {
            this.orgData = []
          }
        })
        .catch(data => {
          this.errorMessage()
        })
        .finally(() => {
          if (this.loadingInstance) {
            setTimeout(() => {
              this.loadingInstance.close()
            }, 400)
          }
        })
    },

    getDeptType() {
      getOrgType()
        .then(data => {
          if (data.code === '00000000') {
            this.orgTypeList = data.payload.results.OrgTypes
            if (this.orgTypeList && this.orgTypeList.length > 0) {
              this.orgType = this.orgTypeList[0].id
              this.getOrgData()
              this.setOrgType(this.orgTypeList)
            }
          }
        })
        .catch(data => {
          this.orgTypeList = []
          this.errorMessage()
        })
        .finally(() => {
          if (this.loadingInstance) {
            setTimeout(() => {
              this.loadingInstance.close()
            }, 400)
          }
        })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@treeHeight: 44px;
/deep/ .dept-tree-cla {
  overflow: hidden;
  .custom-tree-node::before {
    position: absolute;
    top: 22px;
    content: '';
    height: 100%;
    width: 1px;
    border-left: 1px dashed rgba(0, 0, 0, 0.2);
  }
  .el-tree-node {
    position: relative;
  }
  .leaf-node-cla::before {
    display: none;
  }
  .el-tree-node__content > .el-tree-node__expand-icon {
    position: relative;
    left: 12px;
    z-index: 500;
    background-color: transparent;
    border-radius: 50%;
  }

  .el-tree-node__expand-icon.is-leaf {
    padding: 2px;
  }
  .el-tree-node__content {
    line-height: 44px;
    height: 44px;
  }

  .el-tree-node__content:hover {
    background-color: #ffffff;
  }

  .is-current {
    .el-tree-node__content {
      background-color: #ffffff;
    }
  }
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-right: 20px;
  align-items: center;
  z-index: 100;
  .node-text-cla {
    padding-left: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 0;
  }
  .el-button-group {
    display: none;
    align-items: center;
    /deep/.icon-btn-cla {
      color: @themeColor;
    }
  }
  &:hover {
    .node-text-cla {
      color: @themeColor;
    }
    .el-button-group {
      display: flex;
      color: @themeColor;
    }
  }
}
.leaf-node-cla {
  .node-text-cla {
    font-family: PingFangSC-Regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/orgStructure/orgTree.vue